import React from "react";

export const WhiteLinkedinLogo = () => (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.50253 16H0.978069V5.31762H4.50253V16ZM2.7384 3.86044C1.6114 3.86044 0.697266 2.98185 0.697266 1.92111C0.697266 1.4116 0.912314 0.92296 1.2951 0.562681C1.67789 0.202403 2.19706 0 2.7384 0C3.27975 0 3.79892 0.202403 4.18171 0.562681C4.56449 0.92296 4.77954 1.4116 4.77954 1.92111C4.77954 2.98185 3.86503 3.86044 2.7384 3.86044ZM17.6935 16H14.1766V10.7999C14.1766 9.56057 14.15 7.97125 12.3442 7.97125C10.5117 7.97125 10.2309 9.31771 10.2309 10.7106V16H6.71026V5.31762H10.0905V6.77479H10.1399C10.6104 5.93549 11.7598 5.04976 13.4746 5.04976C17.0416 5.04976 17.6973 7.26052 17.6973 10.132V16H17.6935Z"
            fill="white"
        />
    </svg>
);
